import { Box, Stack, Text, Title } from '@mantine/core';
import { Navigate, useParams } from 'react-router-dom';

import { BulkUploadForm } from '../components/BulkUpload/BulkUploadForm';
import { ContentBackLink } from '../components/ContentBackLink';
import { ContentExitProvider } from '../components/ContentExitContext';
import { MEDIA_CONFIG, isBulkUploadType } from '../constants/mediaConfig';
import { useContentPages } from '../hooks/useContentPages';

import { ListLoader } from '@/components';
import { Platform } from '@/features/pages';
import { useDepartmentStore } from '@/stores/department';

const isPlatform = (value: string): value is Platform =>
  value === 'instagram' || value === 'telegram';

export const BulkUploadPage = () => {
  const { platform, pageId, mediaType } = useParams<{
    platform: string;
    pageId: string;
    mediaType: string;
  }>();
  const department = useDepartmentStore((state) => state.selected);
  const { pages, isLoading } = useContentPages(department);

  if (!pageId || !platform || !isPlatform(platform) || !isBulkUploadType(mediaType)) {
    return <Navigate to="/content" replace />;
  }

  const page = pages.find((item) => item.pageId === pageId && item.platform === platform);

  if (isLoading) {
    return <ListLoader />;
  }

  if (!page) {
    return <Navigate to="/content" replace />;
  }

  const config = MEDIA_CONFIG[mediaType];

  return (
    <ContentExitProvider>
      <Box>
        <ContentBackLink />

        <Stack gap={4} mb="xl">
          <Title order={2}>Bulk upload — {config.title}</Title>
          <Text size="sm" c="dimmed">
            {platform === 'instagram' ? 'Instagram' : 'Telegram'}: {page.name} · Регион:{' '}
            {department.toUpperCase()}
          </Text>
        </Stack>

        <BulkUploadForm
          department={department}
          pageId={pageId}
          platform={platform}
          mediaType={mediaType}
        />
      </Box>
    </ContentExitProvider>
  );
};
